import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RoleAccessLayer from "../../components/RoleAccessLayer";
import ComprobantesAdminLayer from "../../components/comprobantes/ComprobantesAdminLayer"

const ComprobantesAdmi = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Comprobantes Administrador" />

        {/* RoleAccessLayer */}
        <ComprobantesAdminLayer/>

      </MasterLayout>

    </>
  );
};

export default ComprobantesAdmi; 
 